
import { Component, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromTap from 'app/state/tap';
import { computed } from '@angular/core';

@Component({
  selector: 'app-taps',
  templateUrl: './taps.component.html',
  styleUrls: ['./taps.component.scss'],
  standalone: true,
  imports: [IonicModule]

})
export class TapsComponent {

  items = this.store.selectSignal(fromTap.selectTapsNotInSelectedTower);



  constructor(
    private store: Store,
    private modalController: ModalController
  ) { }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async selectTap(tap: any) {
    await this.modalController.dismiss(tap);
  }

}
